import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, NG_VALUE_ACCESSOR } from '@angular/forms';


@Component({
  selector: 'app-form-field-input-mask',
  templateUrl: './form-field-input-mask.component.html',
  styleUrls: ['./form-field-input-mask.component.scss'],
  providers:[
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormFieldInputMaskComponent),
      multi: true
    }
  ]
})
export class FormFieldInputMaskComponent implements OnInit {

  @Input() label!: string;
  @Input() required!: boolean;
  @Input() isInline!: boolean;
  @Input() control!: AbstractControl;
  @Input() patternError!: string;
  @Input() icon!: string;
  @Input() iconLabel!: boolean;
  @Input() mask: any;
  @Input() isPrefix!: boolean;
  @Input() prefix!: number;

  @Input() placeholder!: string;
  @Output() changed = new EventEmitter<string>();

  value!: string;
  isDisabled!: boolean;

  constructor() { }

  ngOnInit(): void {
  }

  hasError(): boolean{
    return this.control && this.control.invalid && this.control.touched;
  }

  get errorKey() {
    return this.control && this.control.errors && Object.keys(this.control.errors)[0];
  }

  private propagateChange: any = () => { };
  private propagateTouched: any = () => { };

  writeValue(value: string): void{
    this.value = value;
  }

  registerOnChange(fn: any): void{
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void{
    this.propagateTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void{
    this.isDisabled = isDisabled;
  }

  onKeyup(value: string): void {
    const values = value ? value.replace('-', '').replace('-', '') : value;
    this.value = value;
    this.propagateChange(values);
    this.changed.emit(values);
  }

  onBlur(): void {
    this.propagateTouched();
  }

}
